import React, { useEffect, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Table,
} from "reactstrap"

import downArrowIcon from "../../../assets/images/icons/down-arrow-color.svg"
import NoData from "../../../assets/images/noData.svg"
import { useLazyGetDashboardMaturityTrackingQuery } from "store/api/wealthpartnerapi/wealthReport"
import moment from "moment"
import { formatAmount } from "helpers/common"
import { useLazyGetDashboardMaturityTrackingAdminQuery } from "store/api/reports/reports"

const periods = [
  "This Year",
  "This Half Year",
  "This Quarter",
  "This Month",
  "This Week",
]

const MaturityTracking = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggle = () => setDropdownOpen((prevState) => !prevState)
  const [period, setPeriod] = useState("This Month")
  const [data, setData] = useState([])
  const [getResults, { isFetching }] =
    useLazyGetDashboardMaturityTrackingAdminQuery()

  const getList = async () => {
    try {
      const { data } = await getResults({ period }).unwrap()
      setData(data)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [period])

  return (
    <React.Fragment>
      <div className="summery-filter-details-table">
        <div className="filter-section">
          <h4>Maturity</h4>

          <div className="filter-dropdown-section">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle caret size="lg">
                {period} <img src={downArrowIcon} alt="" />
              </DropdownToggle>
              <DropdownMenu style={{ minWidth: "auto" }}>
                {periods.map((item, index) => (
                  <DropdownItem
                    key={`periods_${index}`}
                    onClick={() => setPeriod(item)}
                  >
                    {item}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        <div className="summery-filter-details">
          <Table responsive>
            <thead>
              <tr>
                <th
                  style={{
                    backgroundColor: "#414141",
                    color: "#fff",
                  }}
                >
                  Date
                </th>
                <th
                  style={{
                    backgroundColor: "#7C7C7C",
                    color: "#fff",
                  }}
                  className="action text-center"
                >
                  Name
                </th>
                <th
                  style={{
                    backgroundColor: "#9F9F9F",
                    color: "#fff",
                  }}
                  className="action text-center"
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={`top_performer_${index}`}>
                  <td>{moment(item.repayment_date).format("D MMM YYYY")}</td>
                  <td>
                    <div className="text-center">{item.investor_name}</div>
                  </td>
                  <td>
                    <div className="amount text-center">
                      ₹ {formatAmount(item.amount)}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {!isFetching && data.length <= 0 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "250px",
              }}
            >
              <img
                src={NoData}
                style={{
                  maxWidth: "160px",
                }}
                alt="Record not found"
              />
              <h4
                style={{
                  color: "#000000",
                  fontSize: "16px",
                  fontWeight: "600",
                  marginTop: "15px",
                  marginBottom: "5px",
                  textAlign: "center",
                }}
              >
                No Records Found
              </h4>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default MaturityTracking
